import React, { useState, useEffect } from "react";
import useApiStable from "../../utils/useApiStable";

const GroupPhaseResultTable = ({ groupId, matches, teams = [] }) => {
  const api = useApiStable();
  const [standings, setStandings] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!groupId) {
      setStandings([]);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    api
      .get(`/tournaments/groups/${groupId}/standings`)
      .then((data) => {
        setStandings(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching standings:", error);
        setError(error.message);
        setLoading(false);
      });
  }, [api, groupId, matches]);

  const getTeamName = (teamId) => {
    const team = teams.find((entry) => entry.id === teamId);
    if (!team) {
      return teamId;
    }
    if (team.displayName) {
      return team.displayName;
    }
    if (team.name) {
      return team.name;
    }
    if (Array.isArray(team.players) && team.players.length > 0) {
      return team.players.map((player) => player.name).join(" / ");
    }
    return teamId;
  };

  if (loading) return <div>Lade Tabelle...</div>;
  if (error) return <div>Fehler beim Laden der Tabelle: {error}</div>;

  return (
    <div className="groupphase-section">
      <h2>Gruppen-Tabelle</h2>
      <div className="groupphase-table-container">
        <table className="groupphase-table">
          <thead>
            <tr>
              <th>Platz</th>
              <th>Team</th>
              <th>Spiele</th>
              <th>Siege</th>
              <th>Niederl.</th>
              <th>Sätze +</th>
              <th>Sätze -</th>
              <th>Punkte</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((row, idx) => {
              const teamId = row.teamId ?? row.playerId;
              return (
                <tr key={teamId}>
                  <td>{idx + 1}</td>
                  <td>{getTeamName(teamId)}</td>
                  <td>{row.matches}</td>
                  <td>{row.wins}</td>
                  <td>{row.losses}</td>
                  <td>{row.setsWon}</td>
                  <td>{row.setsLost}</td>
                  <td>{row.points}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupPhaseResultTable;
